import { IAppState } from '../app.state';
import { createSelector } from '@ngrx/store';
import { INotificationsState } from './notifications.state';

const selectNotificationsState = (state: IAppState) => state.notifications;
export const selectNotifications = createSelector(
  selectNotificationsState,
  (state: INotificationsState) =>
    state.notifications.filter(n => !n.notification.is_received)
);
export const selectOldNotifications = createSelector(
  selectNotificationsState,
  (state: INotificationsState) =>
    state.notifications.filter(n => n.notification.is_received)
);
